import userApi from '../../api/userApi';
import firebaseApp from '../../api/firebaseClient';
import presentationApi from '../../api/presentationApi';

const storeState = {
  userId: '',
  displayName: '',
  photoURL: '',
  signedIn: undefined,
  anonymous: undefined,
  newUser: undefined,
  systemMessage: undefined
};

const storeGetters = {
  loggedIn: state => typeof state.signedIn !== 'undefined',
  userId: state => state.userId,
  displayName: state => state.displayName,
  photoURL: state => state.photoURL,
  isAnonymous: state => state.anonymous,
  isNewUser: state => state.newUser,
  systemMessage: state => state.systemMessage
};

const actions = {
  getUser({ dispatch, commit }, firebaseUser) {
    userApi.fetchUser(firebaseUser, (userData) => {
      const user = userData;
      user.anonymous = firebaseUser.isAnonymous;
      commit('RECEIVE_USER', user);
      dispatch('userFetched');
      dispatch('checkResumePresentation');
      if (firebaseUser.providerData.length) {
        const displayName = firebaseUser.providerData[0].displayName;
        const photoURL = firebaseUser.providerData[0].photoURL;
        dispatch('updateUserProfileData', { firebaseUser, displayName, photoURL });
      }

      userApi.fetchAttendedPresentations().then((attendedCollectionSnapshot) => {
        if (!attendedCollectionSnapshot.empty) {
          const attendedCollection = [];
          attendedCollectionSnapshot.forEach((attended) => {
            const attendedData = Object.assign(
              { attendedId: attended.id },
              attended.data()
            );
            attendedCollection.push(attendedData);
          });

          dispatch('fetchRecentAttendedPresentations', attendedCollection);
        }
      });
    });
  },

  updateUserProfileData({ commit }, { firebaseUser, displayName, photoURL }) {
    userApi.updateUserProfile(firebaseUser, displayName, photoURL)
      .then(() => {
        commit('UPDATE_USER_PROFILE', {
          displayName,
          photoURL
        });
      })
      .catch((err) => {
        console.log('Error when updating user profile', err);
      });
  },

  updateUserAttendance({ commit, getters }, { presentationId, presentationData }) {
    const storedAttended = getters.attendedPresentations.filter(attendedPresentation =>
      attendedPresentation.presentationId === presentationId
    );
    const newAttended = storedAttended.length === 0;

    if (newAttended) {
      const attended = {
        presentationId,
        attendingDate: firebaseApp.firebase.firestore.Timestamp.now()
      };

      if (presentationData.slides) {
        attended.favorites = [];
        attended.notes = [];
        presentationData.slides.forEach(() => {
          attended.favorites.push(false);
          attended.notes.push(false);
        });
      }

      userApi.addAttendance(attended).then((attendedRef) => {
        attended.attendedId = attendedRef ? attendedRef.id : presentationId;
        commit('ADD_ATTENDED', attended);
        presentationApi.updateAttendedCount(presentationId);
      });
    } else {
      userApi.updateAttendance(storedAttended[0].attendedId);
    }
  },

  userLoggedIn({ commit }) {
    commit('SYSTEM_MESSAGE', 'Successfully signed in');
  },

  newUserVisit({ commit }, isNew) {
    commit('NEW_USER', isNew);
  },

  signOut({ dispatch, commit }) {
    userApi.signOut().then(() => {
      commit('NEW_USER', {
        userId: '',
        signedIn: undefined,
        anonymous: undefined
      });
      dispatch('unsetRecentAttendedPresentations');
    }).catch((error) => {
      console.log(error);
    });
  }
};

const mutations = {
  RECEIVE_USER(state, user) {
    state.userId = user.userId;
    state.signedIn = user.signedIn;
    state.anonymous = user.anonymous;
  },
  UPDATE_USER_PROFILE(state, userProfile) {
    state.displayName = userProfile.displayName;
    state.photoURL = userProfile.photoURL;
  },
  SYSTEM_MESSAGE(state, message) {
    state.systemMessage = message;
  },
  NEW_USER(state, isNew) {
    state.newUser = isNew;
  }
};

export default {
  state: storeState,
  getters: storeGetters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js